import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const PagoPreRespuesta = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    console.log("=== [PagoPreRespuesta] INICIO ===");
    console.log("[PagoPreRespuesta] URL completa:", window.location.href);
    console.log(
      "[PagoPreRespuesta] Parámetros recibidos:",
      Object.fromEntries(searchParams)
    );
    console.log("=== [PagoPreRespuesta] FIN ===");
  }, [searchParams]);

  return <p>Procesando...</p>;
};

export default PagoPreRespuesta;